export interface Testimonial {
  quote: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Antes pasaba horas los domingos buscando ejercicios. Ahora elijo la disciplina, abro el volumen y sé exactamente qué voy a entrenar. Recuperé mi tiempo libre.',
    author: 'Carlos',
    role: 'Entrenador de club',
    location: 'Madrid, España',
  },
  {
    quote:
      'El Volumen 6 cambió cómo organizo mis grupos mixtos. Ya no hay caos en la pista. Sé exactamente cómo adaptar las sesiones según el nivel de cada atleta.',
    author: 'Mateo',
    role: 'Preparador físico',
    location: 'Buenos Aires, Argentina',
  },
  {
    quote:
      'Las progresiones de saltos son increíbles. Tengo una guía paso a paso para cada disciplina. Mis atletas avanzan más rápido porque sé qué enseñar primero.',
    author: 'Lucía',
    role: 'Entrenadora de escuela',
    location: 'México DF, México',
  },
]
